let cloudinaryImage;
let detail_location;
var selectedImages = [];
let lastSubmittedData = null;
let lastSubmittedImagesLength = 0;
let airTableId = null;
let dataBaseId = null;

document.addEventListener("DOMContentLoaded", async function() {
    detail_location = await fetchIPDetails();
});
const form = document.getElementById('quoteForm')
const submitSuccess = document.getElementById('submitSuccess')
const goBack = document.getElementById('goBack')
const previewDivc = document.querySelector(".preview");
const lead_form = document.getElementById('lead_form')
var checkboxes = document.querySelectorAll('.card.checkbox input[type="checkbox"]');
checkboxes.forEach(function(checkbox, index) {
    var image = document.getElementById('image' + (index + 1));
    checkbox.addEventListener('click', function() {
        var card = this.closest('.card.checkbox');
        if (this.checked) {
            card.classList.add('selected');
            image.classList.add('selected');
        } else {
            card.classList.remove('selected');
            image.classList.remove('selected');
        }
    });
});

document.getElementById("fileInput").addEventListener("change", function(event) {
    const file = event.target.files[0];
    localStorage.setItem('lastSubmittedImagesLength', '0');
    uploadImage(file);
});

function generateUniqueName(baseName = "") {
    const randomString = Math.random().toString(36).substring(2, 12);
    if (baseName) {
        baseName = baseName.trim().replace(/\s+/g, "-").toLowerCase();
    }
    return baseName ? `${baseName}-${randomString}` : `file-${randomString}`;
}

function uploadImage(file) {
    const nameInput = document.querySelector("#name").value.trim();
    const uniqueFileName = generateUniqueName(nameInput);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "pinterest");
    formData.append("cloud_name", "dsfr7nm3a");
    formData.append("public_id", uniqueFileName);
    fetch("https://api.cloudinary.com/v1_1/dsfr7nm3a/image/upload", { method: "POST", body: formData })
        .then(response => response.json())
        .then(data => { console.log("Uploaded Image URL:", data.url); })
        .catch(error => { console.error("Error:", error); });
}

function disableGoBackButtonForThreeSeconds() {
    var countdownElement = document.getElementById("countdown");
    var countdownValue = 5;
    countdownElement.innerText = countdownValue;
    document.getElementById("goBack").style.pointerEvents = "none";
    document.getElementById("goBack").style.color = "#6D6D6D";
    var countdownInterval = setInterval(function () {
        countdownValue--;
        countdownElement.innerText = countdownValue;
        if (countdownValue <= 0) {
            clearInterval(countdownInterval);
            document.getElementById("goBack").style.pointerEvents = "auto";
            document.getElementById("goBack").classList.add("text-primary");
            document.getElementById("goBack").innerText = "Go Back";
        }
    }, 1000);
}

document.querySelector('.submitButton').addEventListener('click', async function (event) {
    event.preventDefault();
    const form = document.getElementById('quoteForm');
    let errors = {};

    const nameInput = form.querySelector('#name');
    const nameValue = nameInput.value.trim();
    if (nameValue === '') {
        errors['name'] = "Name is required";
    }

    const emailInput = form.querySelector('#email');
    const emailValue = emailInput.value.trim();
    function validateMail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
    if (emailValue === '') {
        errors['email'] = "Email is required";
    } else if (!validateMail(emailValue)) {
        errors['email'] = "Invalid email format";
    }

    const phoneInput = form.querySelector('#phone_number');
    const phoneValue = phoneInput.value.trim();
    if (phoneValue === '') {
        errors['phone_number'] = "Phone number is required";
    }

    const checkboxContainerr = document.getElementById('checkboxContainer');
    const chkboxes = checkboxContainerr.querySelectorAll('input[type="checkbox"]');
    let isAnyCheckboxChecked = Array.from(chkboxes).some(checkbox => checkbox.checked);
    if (!isAnyCheckboxChecked) {
        errors['checkboxes'] = "Please select at least one sign type";
    }

    const fileInput = document.getElementById("fileInput");
    const imageUrl = document.getElementById('imageUrl').value.trim();
    const isUrlValid = isValidUrl(imageUrl);
    if (!selectedImages.length && !isUrlValid) {
        errors['CreateFile'] = "Please select at least one image or input a valid URL";
    }

    const placementCheckboxes = document.querySelectorAll('input[type="checkbox"][name="Indoor"], input[type="checkbox"][name="Outdoor"]');
    let isPlacementChecked = false;
    placementCheckboxes.forEach(checkbox => {
        if (checkbox.checked) { isPlacementChecked = true; }
    });
    if (!isPlacementChecked) {
        errors['placement-options'] = "Please select at least one placement option";
    }

    displayErrorMessages(errors);

    if (Object.keys(errors).length === 0) {
        submitForm(form);
    }
});

function displayErrorMessages(errors) {
    clearErrorMessages();
    for (const [field, error] of Object.entries(errors)) {
        const errorElement = document.createElement('div');
        errorElement.className = 'input-form-error';
        errorElement.innerText = error;
        const parentElement = document.querySelector(`#${field}Error`);
        if (parentElement) parentElement.appendChild(errorElement);
        document.getElementById('lead_form').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

function clearErrorMessages() {
    const errorElements = document.querySelectorAll('.input-form-error');
    errorElements.forEach(function (element) { element.parentNode.removeChild(element); });
}

function isValidUrl(url) {
    const pattern = /(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-z]{2,}\/?.*/;
    return pattern.test(url);
}

function saveToLocalStorage(formDataString, imagesLength) {
    localStorage.setItem('lastSubmittedData', formDataString);
    localStorage.setItem('lastSubmittedImagesLength', imagesLength.toString());
}

function getFromLocalStorage() {
    const storedData = localStorage.getItem('lastSubmittedData');
    const storedImagesLength = localStorage.getItem('lastSubmittedImagesLength');
    return {
        lastSubmittedData: storedData || null,
        lastSubmittedImagesLength: storedImagesLength ? parseInt(storedImagesLength) : 0
    };
}

async function submitDataNotPosted() {
    const form = document.getElementById('quoteForm');
    const formData = new FormData(form);
    formData.delete('images[]');
    if (selectedImages.length > 0) {
        selectedImages.forEach(imageObj => { formData.append('images[]', imageObj.file); });
    }
    formData.append('location', detail_location);

    let checkData = false;
    const currentData = {};
    for (const [key, value] of formData.entries()) {
        if (key !== 'lead_page' && key !== 'location') {
            currentData[key] = value;
            if (value && (typeof value === 'string' && value.trim() !== '' || true) && value !== 'null') {
                checkData = true;
            }
        }
    }
    const currentDataString = JSON.stringify(currentData);
    const { lastSubmittedData, lastSubmittedImagesLength } = getFromLocalStorage();
    const imagesChanged = selectedImages.length !== lastSubmittedImagesLength;
    const dataChanged = currentDataString !== lastSubmittedData;

    if (checkData && (dataChanged || imagesChanged)) {
        saveToLocalStorage(currentDataString, selectedImages.length);
        if (dataBaseId) {
            try {
                const deleteRequest = await fetch(`https://apibase.marke-ter.online/api/dummy/signize/${dataBaseId}`, {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                });
                if (!deleteRequest.ok) throw new Error('Delete request failed');
                dataBaseId = null;
            } catch (error) { console.error('Error deleting data:', error); }
        }
        try {
            const response = await fetch('https://apibase.marke-ter.online/api/submit/dummy/signize', { method: 'POST', body: formData });
            if (!response.ok) throw new Error('Submit request failed');
            const data = await response.json();
            dataBaseId = data.form_data?.id;
        } catch (error) { console.error('API request error:', error); }
    }
}

window.addEventListener('beforeunload', function() { submitDataNotPosted() });
document.addEventListener('visibilitychange', function() {
    if (document.hidden) { submitDataNotPosted() }
});

async function validateDummySignages() {
    if (dataBaseId) {
        await fetch(`https://apibase.marke-ter.online/api/dummy/signize/${dataBaseId}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        });
        dataBaseId = null;
    }
}

function submitForm(form) {
    localStorage.setItem('isFormSubmitted', true);
    const submitButton = form.querySelector('.submitButton');
    submitButton.disabled = true;
    submitButton.innerHTML = '<span class="qhf__submit-label">Sending… <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></span>';

    var formData = new FormData(form);
    formData.append('lead_page', document.title || "Info Page");
    formData.append('lead_page_url', window.location.pathname || "Info Page");
    localStorage.setItem("userLeadEmail", formData.get('email'));
    formData.append('event_source', localStorage.getItem('event_keys_data'));
    formData.append('location', detail_location);
    formData.append('leadSource', sessionStorage.getItem('currentURL'));
    formData.delete('images[]');
    formData.append("first_visit", localStorage.getItem("first_visit"));
    formData.append("uuid", localStorage.getItem("ev_session_uuid"));
    formData.append("first_click", localStorage.getItem("first_click"));
    formData.append("visit_count", localStorage.getItem("visit_count"));
    if (selectedImages.length > 0) {
        selectedImages.forEach(function (imageObj) { formData.append('images[]', imageObj.file); });
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://signage.marke-ter.online/api/submit/customBestSigns', true);

    xhr.upload.onprogress = function(e) {
        if (e.lengthComputable) {
            var percentComplete = (e.loaded / e.total) * 100;
            const imgWrappers = document.querySelectorAll('.img-wrapper');
            imgWrappers.forEach(function(wrapper) {
                wrapper.querySelector('.up-loader').style.display = "flex";
                const upLoaderText = wrapper.querySelector('.text');
                if (upLoaderText) { upLoaderText.textContent = `Uploading (${Math.round(percentComplete)}%)`; }
            });
        }
    };

    xhr.onload = function() {
        const resetButton = function() {
            submitButton.disabled = false;
            submitButton.innerHTML = '<span class="qhf__submit-label">Get My Free Quote &amp; Mockup</span>';
        };
        if (xhr.status >= 200 && xhr.status < 300) {
            const data = JSON.parse(xhr.responseText);
            if (data.status === 422) {
                document.querySelectorAll('.error-message').forEach(el => el.parentNode.removeChild(el));
                Object.keys(data.errors).forEach(fieldName => {
                    const errorMessage = data.errors[fieldName][0];
                    const inputField = document.getElementById(fieldName);
                    if (inputField) {
                        const errorElement = document.createElement('div');
                        errorElement.className = 'error-message';
                        errorElement.textContent = errorMessage;
                        errorElement.style.color = 'red';
                        inputField.insertAdjacentElement('afterend', errorElement);
                    }
                });
                form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                resetButton();
                return;
            }

            validateDummySignages();
            localStorage.removeItem('leadPage');
            localStorage.setItem("UUID", data.form_data.UUID);

            const newUrl = `${window.location.pathname}?thanks-for-response`;
            window.history.pushState({}, '', newUrl);
            try { gtag_report_conversion(); } catch (error) { console.error("Error during gtag_report_conversion:", error); }
            try { bingTagFunction(window, document, "script", "//bat.bing.com/bat.js", "uetq"); } catch (error) { console.error("Bing tag error:", error); }
            try { kalviyo(data.form_data.email); } catch (error) { console.error("Klaviyo error:", error); }

            form.classList.add('d-none');
            submitSuccess.classList.remove('d-none');
            form.reset();
            previewDivc.classList.add('d-none');
            lead_form.scrollIntoView({ behavior: 'smooth', block: 'start' });
            disableGoBackButtonForThreeSeconds();
            resetButton();
        } else {
            console.error('Error in submission', xhr.responseText);
            form.classList.add('d-none');
            submitSuccess.classList.remove('d-none');
            form.reset();
            previewDivc.classList.add('d-none');
            lead_form.scrollIntoView({ behavior: 'smooth', block: 'start' });
            disableGoBackButtonForThreeSeconds();
            resetButton();
        }
    };

    xhr.onerror = function() { console.error('Request failed'); };
    xhr.send(formData);
}

goBack.addEventListener('click', () => {
    window.location.reload();
    form.classList.remove('d-none');
    submitSuccess.classList.add('d-none');
});

const openFileInput = () => { document.getElementById("fileInput").click(); };
const fileInput = document.getElementById("fileInput");
const imageUrlInput = document.getElementById('imageUrl');
var imageIndex = 0;
const staticImages = {
    'ai': 'https://cdn.shopify.com/s/files/1/0691/8628/9946/files/Adobe_Illustrator_CC_icon_svg.png?v=1723879074',
    'tiff': 'https://cdn.shopify.com/s/files/1/0691/8628/9946/files/TIFF.png?v=1723879075',
    'pdf': 'https://cdn.shopify.com/s/files/1/0691/8628/9946/files/PDF_file_icon_svg.png?v=1723879075'
};

function previewImages(event) {
    var files = event.target.files;
    for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var fileId = 'file_' + (imageIndex++);
        var fileExtension = file.name.split('.').pop().toLowerCase();
        if (file.type.match('image.*')) {
            var reader = new FileReader();
            reader.onload = (function(file, fileId) {
                return function(event) {
                    selectedImages.push({ id: fileId, file: file, src: event.target.result, name: file.name });
                    updatePreview();
                };
            })(file, fileId);
            reader.readAsDataURL(file);
        } else if (['ai', 'tiff', 'pdf'].includes(fileExtension)) {
            var staticImage = staticImages[fileExtension] || 'path/to/default-static-image.png';
            selectedImages.push({ id: fileId, file: file, src: staticImage, name: file.name });
            updatePreview();
        } else {
            selectedImages.push({ id: fileId, file: file, src: "https://cdn.shopify.com/s/files/1/0691/8628/9946/files/preview.png?v=1723879447", name: file.name });
            updatePreview();
        }
    }
    document.querySelector('.preview').classList.remove('d-none');
    imageUrlInput.value = '';
}

function updatePreview() {
    var previewDiv = document.querySelector('.preview');
    previewDiv.innerHTML = '';
    selectedImages.forEach(function(imageObj) {
        var imgWrapper = document.createElement('div');
        imgWrapper.className = 'img-wrapper';
        imgWrapper.style.display = 'flex';
        imgWrapper.style.flexDirection = 'column';
        imgWrapper.innerHTML = `
            <img src="${imageObj.src || ''}" class="preview-image">
            <span class="remove-icon">×</span>
            <div class="up-loader">
              <img src="https://cdn.shopify.com/s/files/1/0699/3553/0271/files/Group_5.png?v=1729593615" />
              <div class="text">Uploading (0%)</div>
            </div>
        `;
        var removeIcon = imgWrapper.querySelector('.remove-icon');
        removeIcon.onclick = function() {
            selectedImages = selectedImages.filter(function(item) { return item.id !== imageObj.id; });
            updatePreview();
        };
        previewDiv.appendChild(imgWrapper);
    });
}

document.getElementById('imageUrl').addEventListener('input', function () {
    var imageUrl = this.value;
    document.querySelector(".preview").classList.add('d-none');
    if (imageUrl) { fileInput.value = ''; }
    selectedImages = [];
});
